import * as pages from "../pages";

import { Route, Switch } from "react-router-dom";
import Layout from "../shell/components/layout";
import RoutePaths from "./route-paths";
import ReloadRoute from "./ReloadRoute";

function AppRoutes() {
    return (
        <Switch>
            <Layout>
                <Route path={RoutePaths.Root} exact={true} component={pages.HomePage} />
                <Route path={RoutePaths.Home} exact={true} component={pages.HomePage} />
                <Route path={RoutePaths.CreatePartition} component={pages.CreatePartitionPage} />
                <Route path={RoutePaths.ShowPartition} component={pages.ShowPartitionPage} />
                <Route path={RoutePaths.EditPartition} component={pages.EditPartitionPage} />
                <Route path={RoutePaths.Partitions} component={pages.PartitionsPage} />
                <Route path={RoutePaths.EnvironmentConfig} component={pages.EnvironmentConfigPage} />
                <Route path={RoutePaths.Sandbox} component={pages.SandboxPage} />
                <Route path={RoutePaths.AdjustmentAllocation} component={pages.AdjustmentAllocationPage} />
                <Route path={RoutePaths.MovementAllocation} component={pages.MovementAllocationPage} />
                <Route path={RoutePaths.CreatePreAlert} component={pages.CreatePreAlertPage} />
                <Route path={RoutePaths.ConsistencyCheck} component={pages.ConsistencyCheckPage} />
                <Route path={RoutePaths.StockTransferImport} component={pages.StockTransferImportPage} />
                <Route path={RoutePaths.ManageNodes} component={pages.ManageNodesPage} />
                <Route path={RoutePaths.ManageProducts} component={pages.ManageProductsPage} />
                <Route path={RoutePaths.ImportHistoricResultsPage} component={pages.ImportHistoricResultsPage} />
                <Route path={RoutePaths.Product} component={pages.ProductPage} />
                <Route path={RoutePaths.ReloadRoute} component={ReloadRoute} />
            </Layout>
        </Switch>
    );
}

export default AppRoutes;
